export enum GameDistributionEventType {
    Ready = "SDK_READY",
    Error = "SDK_ERROR",
    GameStart = "SDK_GAME_START",
    GamePause = "SDK_GAME_PAUSE",
    Tracking = "SDK_GDPR_TRACKING",
    Targeting = "SDK_GDPR_TARGETING",
    RewardedWatchComplete = "SDK_REWARDED_WATCH_COMPLETE",
    ContentResumeRequested = "CONTENT_RESUME_REQUESTED",
    AllAdsCompleted = "ALL_ADS_COMPLETED",
    AdSdkCanceled = "AD_SDK_CANCELED",
    AdError = "AD_ERROR"
}
